// extracted by mini-css-extract-plugin
export var header = "_vp-1";
export var maskBottom = "_vp-6";
export var maskMiddle = "_vp-7";
export var maskTop = "_vp-5";
export var root = "_vp-0";
export var scrollDownButton = "_vp-3";
export var scrollDownButtonHidden = "_vp-4";
export var viewport = "_vp-2";